<!-- eslint-disable vue/require-v-for-key -->
<template>
  <v-menu
      v-model="menu"
      :close-on-content-click="false"
      :nudge-width="320"
      offset-y
  >
    <template v-slot:activator="{ on, attrs }">
      <v-icon v-bind="attrs" v-on="on" size="16" color="secondary">{{active ? 'mdi-filter' : 'mdi-filter-outline'}}</v-icon>
    </template>
    <v-card class="pa-4" color="filter-wrapper" v-if="!lazyLoading">
      <template v-if="type === 'range'">
        <v-sheet class="pa-3">
        <v-range-slider
            v-model="model"
            :max="max"
            :min="min"
            hide-details
            step="0.01"
            class="align-center d-block"
        >
          <template v-slot:append>
            <v-row>
              <v-col>
                <v-text-field type="number" label="Min" :value="model[0]" @change="$set(model, 0, $event)"></v-text-field>
              </v-col>
              <v-col>
                <v-text-field type="number" label="Max" :value="model[1]" @change="$set(model, 1, $event)"></v-text-field>
              </v-col>
            </v-row>
          </template>
        </v-range-slider>
        </v-sheet>
      </template>
      <template v-else-if="type === 'date'">
        <h3>Date Range</h3>
        <div>
          <v-row align="center">
            <v-col :cols="firstMenuValue === rangeFirstMenuItems[4] ? 5 : 6" :sm="firstMenuValue === rangeFirstMenuItems[4] ? 5 : 6">
              <v-select
                :items="rangeFirstMenuItems"
                variant="outlined"
                v-model="firstMenuValue"
                v-on:change="changeFirstMenuValue"
                class="cst-select"
                bg-color="success"
              ></v-select>
            </v-col>
            <v-col cols="2" sm="2" v-if="firstMenuValue === rangeFirstMenuItems[4]">
              <v-text-field
                  type="number"
                  v-model="lastValue"
                  bg-color="white"
              >
              </v-text-field>
            </v-col>
            <v-col :cols="firstMenuValue === rangeFirstMenuItems[4] ? 5 : 6" :sm="firstMenuValue === rangeFirstMenuItems[4] ? 5 : 6">
                <div v-if="firstMenuValue !== rangeFirstMenuItems[2]">
                  <div v-if="firstMenuValue !== rangeFirstMenuItems[0]">
                    <v-select
                      :items="rangeSecondMenuItems"
                      variant="outlined"
                      v-model="secondMenuValue"
                      class="cst-select"
                    ></v-select>
                  </div>
                </div>
                <div v-else>
                  <v-menu
                    ref="dateMenuOne"
                    v-model="dateMenuOne"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    max-width="320px"
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="selectedDateOne"
                        persistent-hint
                        readonly
                        prepend-inner-icon="mdi-calendar"
                        v-bind="attrs"
                        hide-details
                        single-line
                        class="pt-0 mt-0 picker-text"
                        v-on="on"
                        :style="{ background: 'white' }"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      no-title
                      :close-on-content-click="false"
                      v-model="selectedDateOne"
                      @input="dateMenuOne = false"
                      show-current
                    >
                      <v-spacer></v-spacer>
                    </v-date-picker>
                  </v-menu>
                  <v-menu
                    ref="dateMenuTwo"
                    v-model="dateMenuTwo"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    max-width="320px"
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="selectedDateTwo"
                        persistent-hint
                        readonly
                        prepend-inner-icon="mdi-calendar"
                        v-bind="attrs"
                        hide-details
                        single-line
                        class="pt-0 mt-10 picker-text"
                        v-on="on"
                        :style="{ background: 'white' }"
                        bg-color="white"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      no-title
                      :close-on-content-click="false"
                      v-model="selectedDateTwo"
                      @input="dateMenuTwo = false"
                      show-current
                    >
                      <v-spacer></v-spacer>
                    </v-date-picker>
                  </v-menu>
                </div>
              </v-col>
          </v-row>
        </div>
      </template>
      <template v-else>
        <v-text-field
            label="Search in filter..."
            prepend-inner-icon="mdi-magnify"
            solo
            dense
            flat
            @input="debounceSearch"
            v-model="search"
            :loading="loading"
        ></v-text-field>
          <v-list
              flat
              dense
          >
            <v-list-item-group
                multiple
                active-class=""
                dense
            >
              <v-virtual-scroll
                  :items="filteredItems"
                  :item-height="40"
                  bench="50"
                  height="200"
              >
                <template v-slot:default="{ item }">
                  <v-list-item
                      :key="`item-${item.key}`"
                      :value="item.key"
                      dense
                      active-class="text--accent"
                      @change="updateItems(item.key)"
                  >
                    <template v-slot:default="{ active }">
                      <v-list-item-action class="my-0 mr-3">
                        <v-checkbox
                            dense
                            :input-value="model.indexOf(item.key) > -1"
                            color="accent"
                        ></v-checkbox>
                      </v-list-item-action>
                      <v-list-item-content>
                        <v-list-item-title v-text="item.value"></v-list-item-title>
                      </v-list-item-content>
                    </template>
                  </v-list-item>
                  <v-divider class="my-0"></v-divider>
                </template>
              </v-virtual-scroll>
            </v-list-item-group>
          </v-list>
      </template>
      <v-card-actions class="mt-3 ctm-actions">
        <v-btn
            small
            color="secondary"
            class="elevation-0"
            :disabled="!isActive()"
            @click="clearFilter"
        >
          Clear
        </v-btn>
        <v-spacer></v-spacer>
        <v-tooltip v-if="selected.length > 3" top open-delay="600">
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon small class="text-center" v-bind="attrs" v-on="on" @click="tagsExpand = !tagsExpand"><v-icon small>mdi-arrow-{{tagsExpand ? 'up' : 'down'}}</v-icon></v-btn>
          </template>
          <span>{{tagsExpand ? 'Shrink' : 'Expand'}} Selected</span>
        </v-tooltip>
        <v-spacer></v-spacer>
        <v-btn
            color="primary"
            @click="applyFilter"
            small
            class="elevation-0"
        >
          Filter
        </v-btn>
      </v-card-actions>
      <div style="max-width: 300px">
        <v-chip-group show-arrows :column="tagsExpand">
          <v-chip
              v-for="tag in selected"
              :key="tag.key"
              close
              small
              color="primary"
              @click:close="removeItem(tag.key)"
          >
            <v-tooltip top open-delay="1000">
              <template v-slot:activator="{ on, attrs }">
                <span class="selected-chip" v-bind="attrs" v-on="on">{{ tag.value }}</span>
              </template>
              <span>{{ tag.value }}</span>
            </v-tooltip>
          </v-chip>
        </v-chip-group>
      </div>
    </v-card>
    <div v-else style="margin-top: 35%; margin-left: 45%; height: 100px">
      <v-progress-circular
              :size="20"
              color="primary"
              indeterminate
      ></v-progress-circular>
    </div>
  </v-menu>
</template>

<script>
import { debounce } from 'debounce';
import dateRange from '../../helpers/dateRange';

export default {
  props: {
    type: {
      type: String,
      default: 'items'
    },
    items: {
      type: Array,
      default: () => []
    },
    values: {
      default: () => []
    },
    min: {
      type: Number,
      default: null
    },
    max: {
      type: Number,
      default: null
    },
    entity: String,
    isLazyLoad: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      menu: false,
      search: '',
      model: [],
      selected: [],
      loading: true,
      tagsExpand: false,
      lazyLoading: true,
      isFetchingFilters: false,
      rangeFirstMenuItems: ['All Time','Current', 'Between', 'Previous', 'Last...'],
      rangeSecondMenuItems: [],
      firstMenuValue: 'All Time',
      secondMenuValue: null,
      currentItems: ['Today', 'This week', 'This month', 'This quarter', 'This year'],
      previousItems: ['Yesterday', 'Previous week', 'Previous month', 'Previous quarter', 'Previous year'],
      lastItems: ['Hour', 'Day', 'Week', 'Month', 'Quarter', 'Year'],
      selectedDateOne: null,
      selectedDateTwo: null,
      dateMenuOne: false,
      dateMenuTwo: false,
      lastValue: 0,
      range: {
        start: 0,
        end: 0
      },
    }
  },
  methods: {
    debounceSearch: debounce( function (value) {
      this.loading = true;
      this.$emit('search', value, this.entity)
    }, 700),
    updateItems(item) {
      if(this.model.indexOf(item) < 0) {
        this.model.push(item);
      } else {
        this.model.splice(this.model.indexOf(item), 1);
      }
    },
    applyFilter() {
      if (this.type === 'date') {
        switch (this.firstMenuValue) {
          case "All Time":
            this.range = { start: 0, end: 0 };
            break;
          case "Current":
            if (this.secondMenuValue === "Today"){
              this.range = {...dateRange.getToday()};
            } else if (this.secondMenuValue === "This week") {
              this.range = {...dateRange.getThisWeek()};
            } else if (this.secondMenuValue === "This month") {
              this.range = {...dateRange.getThisMonth()};
            } else if (this.secondMenuValue === "This quarter") {
              this.range = {...dateRange.getThisQuarter()};
            } else if (this.secondMenuValue === "This year") {
              this.range = {...dateRange.getThisYear()};
            }
            break;
          case "Between":
            if(this.selectedDateOne && this.selectedDateTwo) {
              const d1 = new Date(this.selectedDateOne).getTime();
              const d2 = new Date(this.selectedDateTwo).getTime();
              if (d1 <= d2)
                this.range = {start: d1, end: d2}
            }
            break;
          case "Previous":
            if (this.secondMenuValue === "Yesterday"){
              this.range = {...dateRange.getYesterday()};
            } else if (this.secondMenuValue === "Previous week") {
              this.range = {...dateRange.getPreviousWeek()};
            } else if (this.secondMenuValue === "Previous month") {
              this.range = {...dateRange.getPreviousMonth()};
            } else if (this.secondMenuValue === "Previous quarter") {
              this.range = {...dateRange.getPreviousQuarter()};
            } else if (this.secondMenuValue === "Previous year") {
              this.range = {...dateRange.getPreviousYear()};
            }
            break;
          case "Last...":
            if(this.secondMenuValue && this.lastValue) {
              this.range = {...dateRange.getLast(Number(this.lastValue), this.secondMenuValue.toLowerCase())};
            }
            break;
        }

        this.menu = false;
        const data = this.range.start && this.range.end ? [Math.round(this.range.start/1000), Math.round(this.range.end/1000)] : [];
        this.$emit('apply', data, this.entity);
        return;
      }

      const data = this.type === 'range' && this.model[0] === this.min && this.model[1] === this.max ? [] : this.model;
      this.$emit('apply', data, this.entity);
      this.menu = false;
    },
    clearFilter() {
      if (this.type === 'range') {
        this.model = [this.min, this.max];
      } else {
        this.model = [];
      }
      this.model = [];
      if (this.type === 'date') {
        this.firstMenuValue = 'All Time'
        this.range = {start:0, end:0}
      }

      this.applyFilter();
    },
    removeItem(id) {
      this.model.splice(this.model.indexOf(id), 1);
    },
    isActive() {
      if (this.type === 'range') {
        return this.min !== this.max;
      } else {
        return this.model.length;
      }
    },
    changeFirstMenuValue() {
      switch (this.firstMenuValue) {
        case "All Time":
          break;
        case this.rangeFirstMenuItems[1]:
          this.rangeSecondMenuItems.length = 0;
          this.rangeSecondMenuItems = [...this.currentItems];
          break;
        case this.rangeFirstMenuItems[3]:
          this.rangeSecondMenuItems.length = 0;
          this.rangeSecondMenuItems = [...this.previousItems];
          break;
        case this.rangeFirstMenuItems[4]:
          this.rangeSecondMenuItems.length = 0;
          this.rangeSecondMenuItems = [...this.lastItems];
          break;
        default:
          this.rangeSecondMenuItems = [];
      }
    },
  },

  mounted() {
    this.model = this.type === 'range' ? [this.min, this.max] : [];
  },
  computed: {
    active() {
      if (this.type === 'range') {
        return this.menu || !(this.model[0] === this.min && this.model[1] === this.max)
      } else {
        return this.menu || this.model.length
      }
    },
    filteredItems() {
      this.loading = false;
      let items =  this.search ? this.items.filter(i => i.value.toLowerCase().includes(this.search.toLowerCase())) : this.items;
      items = items.filter(i => i.key);
      if (this.type !== 'range') {
        items.unshift({
          key: 'empty',
          value: 'Empty'
        })
      }

      return items;
    },
  },
  watch: {
    'menu'() {
      if (this.menu && this.isLazyLoad && !this.items.length) {
        this.$emit('getLazyFilters', this.entity);
        this.isFetchingFilters = true;
      }
    },
    values() {
      if(this.values && this.values.length) {
        this.model = this.values;
      } else {
          this.model = this.type === 'range' ? [this.min, this.max] : [];
      }
    },
    model() {
      const selected = [...this.items.filter(i => this.model.indexOf(i.key) >= 0)];
      let newSelected = this.selected.concat(selected)
      newSelected = [...new Map(newSelected.map(item => [item.key, item])).values()];
      this.selected = newSelected.filter(i => this.model.indexOf(i.key) >= 0);
    },
    items() {
      if(this.items.length || this.isFetchingFilters) {
        this.lazyLoading = false;
      }
      const selected = [...this.items.filter(i => this.model.map(m => m.toString()).indexOf(i.key) >= 0)];
      let newSelected = this.selected.concat(selected)
      newSelected = [...new Map(newSelected.map(item => [item.key, item])).values()];
      this.selected = newSelected.filter(i => this.model.map(m => m.toString()).indexOf(i.key) >= 0);
    },
    min() {
      if (!this.values || !this.values.length) {
        this.model[0] = this.type === 'range' ? this.min : this.model[0];
      }
    },
    max() {
      if(!this.values || !this.values.length) {
        this.lazyLoading = false;
      }
      if (!this.values || !this.values.length) {
        this.model[1] = this.type === 'range' ? this.max : this.model[1];
      }
    }
  }
}
</script>

<style scoped lang="sass">
  .v-card.filter-wrapper
    background-color: #E3EEF4 !important
    border: 1px solid #ACC3CF !important

  .cst-select
    width: 200px !important

  .v-text-field__slot
    background-color: white !important

  .v-select ::v-deep .v-select__slot
    background: white
    padding-left: 5% !important

  .v-input ::v-deep input
    background-color: white !important
    padding-left: 15% !important


</style>

